(function () {
  if (!window.gsap) return;

  gsap.ticker.lagSmoothing(100, 16);

  function wireLenisToScrollTrigger() {
    const lenis = window.__lenis;
    if (!window.ScrollTrigger || !lenis || lenis.__stWired) return;
    lenis.__stWired = true;
    lenis.on('scroll', ScrollTrigger.update);
    if (ScrollTrigger.getAll().length) ScrollTrigger.refresh();
  }
  document.addEventListener('lenis:ready', wireLenisToScrollTrigger);

  let scrollTriggerReady = null;
  function ensureScrollTrigger() {
    if (scrollTriggerReady) return scrollTriggerReady;
    scrollTriggerReady = new Promise((resolve, reject) => {
      if (window.ScrollTrigger) {
        resolve();
        return;
      }
      const src = window.SimucubeScrollTriggerUrl;
      if (!src) {
        reject(new Error('SimucubeScrollTriggerUrl is not defined'));
        return;
      }
      const script = document.createElement('script');
      script.src = src;
      script.onload = () => (window.ScrollTrigger ? resolve() : reject(new Error('ScrollTrigger failed to load')));
      script.onerror = () => reject(new Error('ScrollTrigger failed to load'));
      document.head.appendChild(script);
    }).then(() => {
      gsap.registerPlugin(ScrollTrigger);
      ScrollTrigger.config({ autoRefreshEvents: 'visibilitychange' });
      applyScrollerDefault();
      wireLenisToScrollTrigger();
    });
    return scrollTriggerReady;
  }

  const SQUEEZE = window.matchMedia('(min-width: 990px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const builders = new Map();
  const active = new Map();

  function getScroller() {
    const pageWrapper = document.querySelector('.page-wrapper');
    return pageWrapper && SQUEEZE.matches ? pageWrapper : undefined;
  }

  const inViewCache = new Map();

  function inViewportNow(el) {
    if (inViewCache.has(el)) return inViewCache.get(el);
    const rect = el.getBoundingClientRect();
    if (!rect.height && !rect.width) return false;
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    return rect.top < viewportHeight && rect.bottom > 0;
  }

  function primeInViewCache(elements) {
    inViewCache.clear();
    const results = elements.map(inViewportNow);
    elements.forEach((el, index) => inViewCache.set(el, results[index]));
  }

  const PREPARE_ROOT_MARGIN = '0px 0px 400px 0px';
  const revealObservers = new Map();

  function revealObserver(rootMargin, key) {
    const root = getScroller() || null;
    const cacheKey = `${root ? 'scroller' : 'viewport'}|${key}|${rootMargin}`;
    let observer = revealObservers.get(cacheKey);
    if (!observer) {
      observer = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            obs.unobserve(entry.target);
            const step = entry.target[key];
            if (!step) return;
            delete entry.target[key];
            step();
          });
        },
        { root, rootMargin },
      );
      revealObservers.set(cacheKey, observer);
    }
    return observer;
  }

  function resetRevealObservers() {
    revealObservers.forEach((observer) => observer.disconnect());
    revealObservers.clear();
    document.querySelectorAll('[data-reveal]').forEach((el) => {
      if (!el.__scRevealPrepare && !el.__scRevealPlay) return;
      delete el.__scRevealPrepare;
      delete el.__scRevealPlay;
      delete el.__scReveal;
    });
  }

  function playRootMargin(start) {
    const percent = /(\d+(?:\.\d+)?)\s*%/.exec(start || '');
    const offset = percent ? Math.min(100, Math.max(0, 100 - parseFloat(percent[1]))) : 20;
    return `0px 0px -${offset}% 0px`;
  }

  function schedulePlay(el, start, play) {
    const rect = el.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const percent = /(\d+(?:\.\d+)?)\s*%/.exec(start || '');
    const threshold = (percent ? parseFloat(percent[1]) : 80) / 100;
    if (rect.top <= viewportHeight * threshold) {
      play();
      return;
    }
    el.__scRevealPlay = play;
    revealObserver(playRootMargin(start), '__scRevealPlay').observe(el);
  }

  function scheduleReveal(el, start, prepare) {
    if (typeof IntersectionObserver === 'undefined' || inViewportNow(el)) {
      const play = prepare();
      if (play) play();
      return;
    }
    el.__scRevealPrepare = () => {
      const play = prepare();
      if (play) schedulePlay(el, start, play);
    };
    revealObserver(PREPARE_ROOT_MARGIN, '__scRevealPrepare').observe(el);
  }

  function unobserveReveal(el) {
    if (!el.__scRevealPrepare && !el.__scRevealPlay) return;
    delete el.__scRevealPrepare;
    delete el.__scRevealPlay;
    revealObservers.forEach((observer) => observer.unobserve(el));
  }

  function markRevealReady(el) {
    el.dataset.revealReady = '';
  }

  (function neutralizeSmoothScroll() {
    const pw = document.querySelector('.page-wrapper');
    if (pw) pw.style.scrollBehavior = 'auto';
  })();

  function applyScrollerDefault() {
    if (!window.ScrollTrigger) return;
    ScrollTrigger.defaults({ scroller: getScroller() });
  }

  function build(el) {
    if (active.has(el) || reducedMotion.matches) return;
    const builder = builders.get(el.dataset.gsap);
    if (!builder) return;
    active.set(el, null);
    ensureScrollTrigger()
      .then(() => {
        if (active.get(el) !== null || reducedMotion.matches) return;
        active.set(
          el,
          gsap.context(() => builder(el, getScroller()), el),
        );
      })
      .catch(() => active.delete(el));
  }

  function revert(el) {
    if (!active.has(el)) return;
    const ctx = active.get(el);
    if (ctx) ctx.revert();
    active.delete(el);
  }

  function revertAll() {
    [...active.keys()].forEach(revert);
  }

  const restartStatementLogosMarquee = (scope) => {
    const root = scope instanceof Element ? scope : document;
    const motionEls = [...root.querySelectorAll('.statement-logos__track-motion')];
    if (!motionEls.length) return;
    motionEls.forEach((motionEl) => {
      motionEl.style.animation = 'none';
    });
    void motionEls[0].offsetWidth;
    motionEls.forEach((motionEl) => {
      motionEl.style.animation = '';
    });
  };

  function blurReveal(targets) {
    if (!targets.length) return null;
    gsap.set(targets, { yPercent: 24, autoAlpha: 0 });
    return () =>
      gsap.to(targets, {
        yPercent: 0,
        autoAlpha: 1,
        duration: 0.9,
        ease: 'power3.out',
        stagger: 0.05,
        onComplete: () => gsap.set(targets, { clearProps: 'transform,opacity,visibility' }),
      });
  }

  function lineTextFromHtml(html) {
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    return tmp.textContent.replace(/[^\S\u00a0]+/g, ' ').replace(/^ +| +$/g, '');
  }

  function renderLineProbes(el) {
    const source = (el.__scSource ??= el.innerHTML);
    const authorLines = source.split(/<br\s*\/?>/i).map(lineTextFromHtml);
    if (el.matches('h1, h2, h3, h4, h5, h6, a, button, [role]')) {
      el.setAttribute('aria-label', authorLines.join(' '));
    }

    el.innerHTML = authorLines
      .map((line) =>
        line
          .split(' ')
          .filter(Boolean)
          .map((w) => `<span class="sc-line-probe">${w}</span>`)
          .join(' '),
      )
      .join('<br>');
  }

  function measureLineProbes(el) {
    const visualLines = [];
    let lastTop = null;
    let current = null;
    el.querySelectorAll('.sc-line-probe').forEach((probe) => {
      const top = Math.round(probe.offsetTop);
      if (top !== lastTop) {
        current = [];
        visualLines.push(current);
        lastTop = top;
      }
      current.push(probe.textContent);
    });
    return visualLines;
  }

  function writeLineReveal(el, visualLines) {
    el.innerHTML = visualLines
      .map(
        (words) =>
          `<span class="sc-line" aria-hidden="true"><span class="sc-line__in">${words.join(' ')}</span></span>`,
      )
      .join('');

    const inners = el.querySelectorAll('.sc-line__in');
    if (!inners.length) return null;

    if (el.__scRevealed) {
      gsap.set(inners, { yPercent: 0 });
      markRevealReady(el);
      return null;
    }

    gsap.set(inners, { yPercent: 100 });
    markRevealReady(el);
    return inners;
  }

  function animateLineReveal(el, inners) {
    gsap.to(inners, {
      yPercent: 0,
      duration: 0.95,
      ease: 'power3.out',
      stagger: 0.11,
      onComplete: () => {
        el.__scRevealed = true;
      },
    });
  }

  function riseReveal(el) {
    if (el.__scRise) return null;
    if (el.closest('[data-product-info-track]')) return null;
    el.__scRise = true;
    const mask = document.createElement('span');
    mask.className = 'sc-line sc-rise';
    el.parentNode.insertBefore(mask, el);
    mask.appendChild(el);
    gsap.set(el, { yPercent: 100 });
    markRevealReady(el);
    return () =>
      gsap.to(el, {
        yPercent: 0,
        duration: 0.95,
        ease: 'power3.out',
        delay: parseFloat(el.dataset.revealDelay || 0),
      });
  }

  function rebuildLines(elements) {
    if (reducedMotion.matches) return;
    const viewport = window.innerWidth;
    const stale = elements.filter((el) => {
      const width = el.clientWidth;
      if (!width || !el.offsetParent) return false;
      if (el.__scLineWidth === width && el.__scLineViewport === viewport) return false;
      el.__scLineWidth = width;
      el.__scLineViewport = viewport;
      return true;
    });

    stale.forEach((el) => {
      if (el.__scLineCtx) el.__scLineCtx.revert();
      renderLineProbes(el);
    });
    const measuredLines = stale.map(measureLineProbes);
    const lineInners = stale.map((el, index) => {
      let inners = null;
      el.__scLineCtx = gsap.context(() => {
        inners = writeLineReveal(el, measuredLines[index]);
      }, el);
      return inners;
    });
    stale.forEach((el, index) => {
      const inners = lineInners[index];
      if (!inners) {
        delete el.__scLinePlay;
        return;
      }
      el.__scLinePlay = () => el.__scLineCtx.add(() => animateLineReveal(el, inners));
      if (el.__scLineWantsPlay) el.__scLinePlay();
    });
  }

  function playLineReveal(el) {
    el.__scLineWantsPlay = true;
    if (el.__scLinePlay) el.__scLinePlay();
  }

  const lineRebuildQueue = new Set();
  function queueLineRebuild(el) {
    if (!lineRebuildQueue.size) {
      requestAnimationFrame(() => {
        const queued = [...lineRebuildQueue];
        lineRebuildQueue.clear();
        rebuildLines(queued);
      });
    }
    lineRebuildQueue.add(el);
  }

  const lineObserver =
    typeof ResizeObserver !== 'undefined'
      ? new ResizeObserver((entries) => entries.forEach((entry) => queueLineRebuild(entry.target)))
      : null;

  function revertReveal(el) {
    unobserveReveal(el);
    if (el.__scRevealCtx) {
      el.__scRevealCtx.revert();
      delete el.__scRevealCtx;
    }
    if (el.__scLineCtx) {
      el.__scLineCtx.revert();
      delete el.__scLineCtx;
    }
    if (lineObserver) lineObserver.unobserve(el);
    delete el.__scReveal;
    delete el.__scRevealed;
    delete el.__scRise;
    delete el.__scLineWidth;
    delete el.__scLineViewport;
    delete el.__scLinePlay;
    delete el.__scLineWantsPlay;
  }

  function revertRevealsInScope(scope) {
    const root = scope instanceof Element ? scope : document;
    const nodes = new Set();
    if (root.matches?.('[data-reveal]')) nodes.add(root);
    root.querySelectorAll('[data-reveal]').forEach((node) => nodes.add(node));
    nodes.forEach(revertReveal);
  }

  function setupReveals(scope) {
    const root = scope instanceof Element ? scope : document;
    const nodes = new Set();
    if (root.matches && root.matches('[data-reveal]')) nodes.add(root);
    root.querySelectorAll('[data-reveal]').forEach((n) => nodes.add(n));

    if (!reducedMotion.matches) {
      primeInViewCache([...nodes].filter((el) => !el.__scReveal));
    }

    nodes.forEach((el) => {
      if (el.__scReveal) return;
      el.__scReveal = true;
      if (reducedMotion.matches) return;

      const revealStart = el.dataset.revealStart;

      if (el.dataset.reveal === 'lines') {
        scheduleReveal(el, revealStart || 'top 80%', () => {
          const start = () => {
            queueLineRebuild(el);
            if (lineObserver) lineObserver.observe(el);
          };
          if (document.fonts && document.fonts.ready) document.fonts.ready.then(start);
          else start();
          return () => playLineReveal(el);
        });
        return;
      }

      if (el.dataset.reveal === 'rise') {
        scheduleReveal(el, revealStart || 'top 80%', () => {
          let play = null;
          el.__scRevealCtx = gsap.context(() => {
            play = riseReveal(el);
          }, el);
          return play && (() => el.__scRevealCtx.add(play));
        });
        return;
      }

      if (el.dataset.reveal === 'fade') {
        scheduleReveal(el, revealStart || 'top 80%', () => {
          el.__scRevealCtx = gsap.context(() => {
            gsap.set(el, { autoAlpha: 0 });
            markRevealReady(el);
          }, el);
          return () =>
            el.__scRevealCtx.add(() =>
              gsap.to(el, {
                autoAlpha: 1,
                duration: 0.75,
                ease: 'power2.out',
                delay: parseFloat(el.dataset.revealDelay || 0),
              }),
            );
        });
        return;
      }

      if (el.dataset.reveal === 'count') {
        scheduleReveal(el, revealStart || 'top 85%', () => {
          let play = null;
          el.__scRevealCtx = gsap.context(() => {
            const original = el.textContent || '';
            const match = original.match(/-?\d[\d,]*(\.\d+)?/);
            if (!match) {
              markRevealReady(el);
              return;
            }

            const raw = match[0];
            const target = parseFloat(raw.replace(/,/g, ''));
            if (!isFinite(target)) {
              markRevealReady(el);
              return;
            }

            const decimals = (raw.split('.')[1] || '').length;
            const grouped = raw.includes(',');
            const prefix = original.slice(0, match.index);
            const suffix = original.slice(match.index + raw.length);
            const counter = { value: parseFloat(el.dataset.revealCountFrom || 0) };

            const render = () => {
              const fixed = counter.value.toFixed(decimals);
              const shown = grouped
                ? Number(fixed).toLocaleString('en-US', { minimumFractionDigits: decimals })
                : fixed;
              el.textContent = prefix + shown + suffix;
            };
            render();
            markRevealReady(el);

            play = () =>
              gsap.to(counter, {
                value: target,
                duration: parseFloat(el.dataset.revealCountDuration || 1.6),
                ease: 'power2.out',
                delay: parseFloat(el.dataset.revealDelay || 0),
                onUpdate: render,
                onComplete: () => {
                  el.textContent = original;
                },
              });

            return () => {
              el.textContent = original;
            };
          }, el);
          return play && (() => el.__scRevealCtx.add(play));
        });
        return;
      }

      if (el.dataset.reveal === 'chars-scrub') {
        scheduleReveal(el, 'top 85%', () => {
          el.__scRevealCtx = gsap.context(() => {
            const text = (el.textContent || '').replace(/\s+/g, ' ').trim();
            el.setAttribute('aria-label', text);
            el.innerHTML = text
              .split(' ')
              .map(
                (word) =>
                  `<span class="sc-word" aria-hidden="true">` +
                  [...word].map((ch) => `<span class="sc-char">${ch}</span>`).join('') +
                  `</span>`,
              )
              .join(' ');
            const chars = el.querySelectorAll('.sc-char');
            markRevealReady(el);
            if (!chars.length) return;
            gsap.set(chars, { opacity: 0.1 });
            ensureScrollTrigger()
              .then(() =>
                el.__scRevealCtx.add(() =>
                  gsap.to(chars, {
                    opacity: 1,
                    ease: 'power2.in',
                    duration: 0.12,
                    stagger: { each: 0.12 },
                    scrollTrigger: { trigger: el, start: 'top 85%', end: 'bottom 55%', scrub: true },
                  }),
                ),
              )
              .catch(() => gsap.set(chars, { opacity: 1 }));
          }, el);
        });
        return;
      }

      if (el.dataset.reveal === 'stagger') {
        if (el.classList.contains('partnership__media') && !SQUEEZE.matches) return;
        const isStatementLogos = el.classList.contains('statement-logos__logos');
        const statementLogosSection = isStatementLogos ? el.closest('.statement-logos') : null;
        const isMobileMarquee = isStatementLogos && window.matchMedia('(max-width: 989px)').matches;

        scheduleReveal(el, revealStart || 'top 72%', () => {
          let play = null;
          el.__scRevealCtx = gsap.context(() => {
            const items = el.children.length ? [...el.children] : [el];
            const toVars = { autoAlpha: 1 };
            const fromVars = { autoAlpha: 0 };
            if (!isMobileMarquee) {
              fromVars.y = 28;
              toVars.y = 0;
            }

            let settled = false;
            const settle = () => {
              if (settled) return;
              settled = true;
              gsap.set(items, { clearProps: 'transform,opacity,visibility' });
              if (statementLogosSection) {
                statementLogosSection.classList.add('statement-logos--marquee-ready');
              }
            };

            gsap.set(items, fromVars);
            markRevealReady(el);

            play = () =>
              gsap.to(items, {
                ...toVars,
                duration: 0.7,
                ease: 'power2.out',
                stagger: 0.09,
                onComplete: settle,
              });

            if (typeof IntersectionObserver === 'undefined') return;
            const io = new IntersectionObserver(
              (entries, obs) => {
                entries.forEach((entry) => {
                  if (!entry.isIntersecting) return;
                  settle();
                  obs.disconnect();
                });
              },
              { rootMargin: '0px 0px -40% 0px' },
            );
            io.observe(el);
            return () => io.disconnect();
          }, el);
          return play && (() => el.__scRevealCtx.add(play));
        });
        return;
      }

      if (el.dataset.reveal === 'blur-stagger') {
        scheduleReveal(el, revealStart || 'top 75%', () => {
          let play = null;
          el.__scRevealCtx = gsap.context(() => {
            play = blurReveal(el.children.length ? [...el.children] : [el]);
            markRevealReady(el);
          }, el);
          return play && (() => el.__scRevealCtx.add(play));
        });
        return;
      }

      scheduleReveal(el, revealStart || 'top 76%', () => {
        let play = null;
        el.__scRevealCtx = gsap.context(() => {
          const from = { autoAlpha: 0 };
          const to = { autoAlpha: 1 };
          switch (el.dataset.revealDir || 'up') {
            case 'down':
              from.y = -28;
              to.y = 0;
              break;
            case 'left':
              from.x = 36;
              to.x = 0;
              break;
            case 'right':
              from.x = -36;
              to.x = 0;
              break;
            case 'scale':
              from.scale = 0.96;
              to.scale = 1;
              break;
            default:
              from.y = 28;
              to.y = 0;
          }
          gsap.set(el, from);
          markRevealReady(el);
          play = () =>
            gsap.to(el, {
              ...to,
              duration: 0.75,
              ease: 'power2.out',
              delay: parseFloat(el.dataset.revealDelay || 0),
            });
        }, el);
        return play && (() => el.__scRevealCtx.add(play));
      });
    });

    inViewCache.clear();
  }

  function initWithin(root, refresh = true) {
    applyScrollerDefault();
    const scope = root || document;
    if (scope instanceof Element && scope.matches('[data-gsap]')) build(scope);
    scope.querySelectorAll('[data-gsap]').forEach(build);
    setupReveals(scope);
    if (refresh && window.ScrollTrigger) ScrollTrigger.refresh();
  }

  function register(name, builder, options) {
    builders.set(name, builder);
    applyScrollerDefault();
    const els = document.querySelectorAll(`[data-gsap="${name}"]`);
    const deferOffscreen = options && options.deferOffscreen;

    if (!deferOffscreen || !('IntersectionObserver' in window)) {
      els.forEach(build);
      return;
    }

    const io = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          build(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { root: getScroller() || null, rootMargin: '600px 0px' },
    );
    els.forEach((el) => io.observe(el));
  }

  reducedMotion.addEventListener('change', () => {
    if (reducedMotion.matches) {
      revertAll();
      revertRevealsInScope(document);
    } else {
      initWithin(document);
    }
  });

  const handleSqueezeBreakpointChange = () => {
    finishAll();
    revertAll();
    resetRevealObservers();
    requestAnimationFrame(() => {
      initWithin(document);
    });
  };

  SQUEEZE.addEventListener('change', handleSqueezeBreakpointChange);

  function finishAll() {
    if (window.ScrollTrigger) {
      ScrollTrigger.getAll().forEach((st) => {
        if (st.animation) st.animation.progress(1);
        if (st.vars.once) st.kill();
      });
    }
    document.querySelectorAll('[data-reveal]').forEach((el) => {
      el.__scRevealed = true;
    });
  }

  /** @type {ReturnType<typeof setTimeout> | undefined} */
  let resizeSettleTimer;
  let lastResizeInnerWidth = window.innerWidth;
  window.addEventListener('resize', () => {
    const widthChanged = window.innerWidth !== lastResizeInnerWidth;
    lastResizeInnerWidth = window.innerWidth;
    if (!widthChanged && !SQUEEZE.matches) return;
    clearTimeout(resizeSettleTimer);
    resizeSettleTimer = setTimeout(() => {
      finishAll();
      applyScrollerDefault();
      rebuildLines([...document.querySelectorAll('[data-reveal="lines"]')].filter((el) => el.__scLineCtx));
      requestAnimationFrame(() => {
        if (window.ScrollTrigger) ScrollTrigger.refresh();
      });
    }, 150);
  });

  document.addEventListener('scroll-container:breakpoint-change', () => {
    resetRevealObservers();
    setupReveals(document);
    if (window.ScrollTrigger) ScrollTrigger.refresh();
  });

  document.addEventListener('shopify:section:load', (event) => {
    initWithin(event.target);
  });
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-gsap]').forEach(revert);
    if (event.target instanceof Element && event.target.matches('[data-gsap]')) revert(event.target);
    revertRevealsInScope(event.target);
  });

  window.addEventListener('orientationchange', () => {
    if (window.ScrollTrigger) ScrollTrigger.refresh();
    document.querySelectorAll('.statement-logos--marquee-ready').forEach((section) => {
      restartStatementLogosMarquee(section);
    });
  });

  window.SimucubeMotion = { register, initWithin, revert, revertReveal, revertRevealsInScope, getScroller };

  register(
    'build-rig',
    (el, scroller) => {
      const steps = el.querySelectorAll('[data-rig-step]');
      if (steps.length < 2 || window.matchMedia('(max-width: 989px)').matches) return;

      el.classList.add('build-rig--animated');

      steps.forEach((step, i) => gsap.set(step, { autoAlpha: i === 0 ? 1 : 0, willChange: 'opacity' }));

      const media = (s) => s.querySelector('.build-rig__step-media') || s;
      const tl = gsap.timeline({
        defaults: { ease: 'power1.inOut' },
        scrollTrigger: {
          trigger: el,
          scroller,
          start: 'top top',
          end: 'bottom bottom',
          scrub: 0.8,
          invalidateOnRefresh: true,
        },
      });

      steps.forEach((step, i) => {
        if (i === 0) return;
        const at = i - 1;
        tl.to(media(steps[i - 1]), { scale: 1.04, duration: 0.85 }, at)
          .to(steps[i - 1], { autoAlpha: 0, duration: 0.4 }, at + 0.25)
          .fromTo(step, { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.4 }, at + 0.35)
          .fromTo(media(step), { scale: 1.04 }, { scale: 1, duration: 0.85 }, at + 0.35);
      });

      return () => el.classList.remove('build-rig--animated');
    },
    { deferOffscreen: true },
  );

  register(
    'perform',
    (el, scroller) => {
      const items = el.querySelectorAll('[data-perform-item]');
      const stages = el.querySelectorAll('[data-stage-index]');
      if (items.length < 2 || window.matchMedia('(max-width: 989px)').matches) return;

      el.classList.add('perform--animated');

      const list = el.querySelector('[data-perform-track]');
      let live = true;
      let current = 0;
      const setActive = (index) => {
        current = index;
        items.forEach((item, i) => item.classList.toggle('perform__item--active', i === index));
        stages.forEach((stage, i) => stage.classList.toggle('is-active', i === index));
      };
      setActive(0);

      const measureLock = () => {
        if (!list || !live) return;
        list.style.minHeight = '';
        el.classList.add('perform--measuring');
        let max = 0;
        items.forEach((_, i) => {
          items.forEach((item, j) => item.classList.toggle('perform__item--active', j === i));
          max = Math.max(max, list.offsetHeight);
        });
        items.forEach((item, j) => item.classList.toggle('perform__item--active', j === current));
        el.classList.remove('perform--measuring');
        list.style.minHeight = `${max}px`;
      };

      if (document.fonts && document.fonts.ready) document.fonts.ready.then(measureLock);
      else measureLock();

      let resizeRaf = null;
      const onResize = () => {
        cancelAnimationFrame(resizeRaf);
        resizeRaf = requestAnimationFrame(measureLock);
      };
      window.addEventListener('resize', onResize);

      let clickJump = null;
      const st = ScrollTrigger.create({
        trigger: el,
        scroller,
        start: 'top top',
        end: 'bottom bottom',
        scrub: 0.8,
        invalidateOnRefresh: true,
        onUpdate: (self) => {
          const index = Math.min(items.length - 1, Math.floor(self.progress * items.length));
          if (clickJump !== null) {
            if (index !== clickJump) return setActive(clickJump);
            clickJump = null;
          }
          setActive(index);
        },
      });

      const releaseJump = () => {
        clickJump = null;
      };
      window.addEventListener('wheel', releaseJump, { passive: true });
      window.addEventListener('touchstart', releaseJump, { passive: true });

      const scrollEl = scroller || window;
      const onClick = (event, i) => {
        if (event.target.closest('a')) return;
        clickJump = i;
        setActive(i);
        const target = st.start + ((i + 0.5) / items.length) * (st.end - st.start);
        if (window.__lenis) window.__lenis.scrollTo(target);
        else scrollEl.scrollTo({ top: target, behavior: 'smooth' });
      };
      const handlers = [...items].map((item, i) => {
        const handler = (event) => onClick(event, i);
        item.addEventListener('click', handler);
        return handler;
      });

      return () => {
        live = false;
        window.removeEventListener('resize', onResize);
        window.removeEventListener('wheel', releaseJump);
        window.removeEventListener('touchstart', releaseJump);
        cancelAnimationFrame(resizeRaf);
        if (list) list.style.minHeight = '';
        el.classList.remove('perform--animated', 'perform--measuring');
        setActive(0);
        items.forEach((item, i) => item.removeEventListener('click', handlers[i]));
      };
    },
    { deferOffscreen: true },
  );

  register(
    'image-banner',
    (el, scroller) => {
      const media = el.querySelector('.image-banner__media');
      const inner = el.querySelector('.image-banner__inner');
      if (!media) return;

      el.classList.add('image-banner--animated');

      const measureMinScale = () => {
        const contentWidth = inner ? inner.offsetWidth : 722;
        const contentTop = inner ? inner.offsetTop : 200;
        const gutter = 48;
        const scaleForWidth = (contentWidth + gutter) / el.offsetWidth;
        const scaleForHeight = contentTop / el.offsetHeight;
        const limitingScale = Math.min(scaleForWidth, scaleForHeight);
        return Math.min(1, Math.max(0.5, limitingScale));
      };

      let minScale = measureMinScale();
      gsap.set(media, { transformOrigin: 'center top', scale: minScale });

      let lockedProgress = 0;
      let isComplete = false;
      let hasStarted = false;

      const applyScale = () => {
        gsap.set(media, { scale: minScale + (1 - minScale) * lockedProgress });
      };

      const st = ScrollTrigger.create({
        trigger: el,
        scroller,
        start: 'top 75%',
        end: 'bottom bottom',
        invalidateOnRefresh: true,
        onEnter: () => {
          hasStarted = true;
          applyScale();
        },
        onUpdate: (self) => {
          if (!hasStarted || isComplete) return;
          if (self.progress >= lockedProgress) {
            lockedProgress = self.progress;
            if (lockedProgress >= 1) {
              lockedProgress = 1;
              isComplete = true;
            }
            applyScale();
          }
        },
        onRefresh: () => {
          minScale = measureMinScale();
          if (!hasStarted) {
            gsap.set(media, { scale: minScale });
            return;
          }
          applyScale();
        },
      });

      const refreshAfterLayout = () => {
        requestAnimationFrame(() => {
          st.refresh();
          if (isComplete) return;
          if (st.progress >= 1) {
            hasStarted = true;
            lockedProgress = 1;
            isComplete = true;
            applyScale();
          } else if (st.progress > lockedProgress) {
            hasStarted = true;
            lockedProgress = st.progress;
            applyScale();
          }
        });
      };
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(refreshAfterLayout);
      else refreshAfterLayout();

      return () => {
        st.kill();
        el.classList.remove('image-banner--animated');
        gsap.set(media, { clearProps: 'transform' });
      };
    },
    { deferOffscreen: true },
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initWithin(document, false));
  } else {
    initWithin(document, false);
  }

  function preloadScrollTrigger() {
    if (reducedMotion.matches) return;
    if (!document.querySelector('[data-gsap], [data-reveal="chars-scrub"]')) return;
    const load = () => ensureScrollTrigger().catch(() => {});
    if ('requestIdleCallback' in window) requestIdleCallback(load, { timeout: 2000 });
    else setTimeout(load, 200);
  }

  if (document.readyState === 'complete') preloadScrollTrigger();
  else window.addEventListener('load', preloadScrollTrigger, { once: true });
})();
